import { UnitType } from '../../../../generated/graphql';
import { RecipeLineFormValue } from './types';

export const EMPTY_RECIPE_LINE: RecipeLineFormValue = {
    stockCardId:  '',
    unitType: UnitType.Pcs,
    warehouseId: '',
    quantity: 1,
    absoluteWaste: 0,
    wastePercentage: 0,
};
